import { type Context, createContext, type MutableRefObject } from 'react';

import noop from 'lodash/noop';

/** How session context is currently shown. `null` means closed. */
export type SessionContextPresentation = 'split' | 'drawer';

export type SplitViewContextValue = {
	presentation: SessionContextPresentation | null;
	/** Opens session context and returns the presentation allowed by the current surface. */
	openSessionContext: (
		requestedPresentation: SessionContextPresentation,
	) => SessionContextPresentation;
	closeSessionContext: () => void;
	rightPanelExitHandlerRef?: MutableRefObject<(() => void) | null>;
};

const openWithRequestedPresentation = (
	requestedPresentation: SessionContextPresentation,
): SessionContextPresentation => requestedPresentation;

export const SplitViewContext: Context<SplitViewContextValue> =
	createContext<SplitViewContextValue>({
		presentation: null,
		openSessionContext: openWithRequestedPresentation,
		closeSessionContext: noop,
	});
